import { HttpContext, HttpContextToken } from '@angular/common/http';

export const SHOULD_ADD_AUTHENTICATION_HEADER = new HttpContextToken<boolean>(() => true);

export const noAuthentification = () => {
  return new HttpContext().set(SHOULD_ADD_AUTHENTICATION_HEADER, false);
};
